<template>
  <div style="padding: 0 10px">
    <div style="text-align: left; margin-bottom: 20px">
      <el-button type="primary" @click="createWarehouse">新建</el-button>
    </div>
    <WmsTable
      :columns="columns"
      :dataSource="dataSource"
      @pageChange="pageChangeCall"
      :is-pagination="false"
    >
      <div
        slot="action"
        slot-scope="{ text, record, index }"
        style="
          display: flex;
          justify-content: space-around;
          align-items: center;
        "
      >
        <a href="javaScript:;" @click="edit(record)">编辑</a>
        <!-- <a href="javaScript:;" @click="del(record)">删除</a> -->
      </div>
    </WmsTable>
    <SetWarehouse
      ref="SetWarehouse"
      @updateWarehouse="updateWarehouse"
      @addWarehouse="addWarehouse"
    ></SetWarehouse>
  </div>
</template>

<script>
import SetWarehouse from "@/views/configure/warehouse/components/SetWarehouse";
import WmsTable from "@/components/WmsTable";
import { columns } from "@/views/configure/warehouse/indexData";
import {
  warehouseList,
  editWarehouse,
  createWarehouse,
} from "@/apis/configure";

export default {
  title: "仓库配置",
  name: "ConfigureWarehouse",
  components: {
    SetWarehouse,
    WmsTable,
  },
  data() {
    return {
      columns,
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      dataSource: [],
    };
  },
  mounted() {
    this.getDataSource();
  },
  methods: {
    pageChangeCall: function (payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
    },
    createWarehouse: function () {
      this.$refs["SetWarehouse"].open();
    },
    edit: function (r) {
      console.log(r)
      this.$refs["SetWarehouse"].open(r);
    },
    del: function (r) {
      let params = r
      params.beactive = 0
      editWarehouse(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("删除成功");
          this.getDataSource();
        }
      });
    },
    getDataSource() {
      warehouseList().then(({ code, data }) => {
        if (code === 0) {
          this.dataSource = data;
        }
      });
    },
    addWarehouse(e) {
      let params = e;
      createWarehouse(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("添加成功");
          this.getDataSource();
          this.$refs["SetWarehouse"].visible = false;
        }
      });
    },
    updateWarehouse(e) {
      let params = e;
      editWarehouse(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("修改成功");
          this.getDataSource();
          this.$refs["SetWarehouse"].visible = false;
        }
      });
    },
  },
};
</script>

<style scoped></style>
